import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { indexOf29nspdgx2e3ap as indexOf } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import {
  add2suhfggl4zvkk as add,
  fromInt2ii0rejb1w62w as fromInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { flushIfNeededwozpffp4tkkx as flushIfNeeded } from './ByteWriteChannel.mjs';
import { writeByte1wjyp0flxjqrr as writeByte } from './ByteWriteChannelOperations.mjs';
import { get_ONEazvfdh9ju3d4 as get_ONE } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/boxedLong/boxedLong.mjs';
import { IOException1wyutdmfe71nu as IOException } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import { decodeToString2ede220pr5xir as decodeToString } from '../../../../../kotlinx-io-kotlinx-io-bytestring/kotlinx/io/bytestring/ByteString.mjs';
import { replace3le3ie7l9k8aq as replace } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function buildPartialMatchTable($this) {
  var table = new Int32Array($this.s4k_1.q2());
  var j = 0;
  var inductionVariable = 1;
  var last = $this.s4k_1.q2();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      while (j > 0 && !($this.s4k_1.r2(i) === $this.s4k_1.r2(j))) {
        j = table[j - 1 | 0];
      }
      if ($this.s4k_1.r2(i) === $this.s4k_1.r2(j)) {
        j = j + 1 | 0;
      }
      table[i] = j;
    }
     while (inductionVariable < last);
  return table;
}
function *advanceToNextPotentialMatch($this, $completion) {
  while (!$this.v4k_1.w3v() || (yield* $this.r4k_1.l4k(VOID, $completion))) {
    var nextMatch = indexOf($this.v4k_1, $this.s4k_1.r2(0));
    if (nextMatch === -1n) {
      var tmp = $this.v4k_1;
      checkBounds($this, (tmp instanceof Buffer() ? tmp : THROW_CCE()).q2());
      $this.y4k_1 = add($this.y4k_1, $this.v4k_1.n4g($this.t4k_1.s4j()));
      yield* flushIfNeeded($this.t4k_1, $completion);
    } else {
      checkBounds($this, nextMatch);
      var tmp_0 = $this;
      var tmp_1 = $this.y4k_1;
      var tmp_2 = $this.t4k_1.s4j();
      tmp_0.y4k_1 = add(tmp_1, $this.v4k_1.k4g(tmp_2 instanceof Buffer() ? tmp_2 : THROW_CCE(), nextMatch));
      yield* flushIfNeeded($this.t4k_1, $completion);
      return Unit_instance;
    }
  }
  return Unit_instance;
}
function *checkFullMatch($this, $completion) {
  while (!$this.v4k_1.w3v() || (yield* $this.r4k_1.l4k(VOID, $completion))) {
    var byte = $this.v4k_1.f3w();
    if ($this.z4k_1 > 0 && !(byte === $this.s4k_1.r2($this.z4k_1))) {
      var oldMatchIndex = $this.z4k_1;
      while ($this.z4k_1 > 0 && !(byte === $this.s4k_1.r2($this.z4k_1))) {
        $this.z4k_1 = $this.w4k_1[$this.z4k_1 - 1 | 0];
      }
      var retained = fromInt(oldMatchIndex - $this.z4k_1 | 0);
      checkBounds($this, retained);
      var tmp = $this;
      var tmp_0 = $this.y4k_1;
      var tmp_1 = $this.t4k_1.s4j();
      tmp.y4k_1 = add(tmp_0, $this.x4k_1.k4g(tmp_1 instanceof Buffer() ? tmp_1 : THROW_CCE(), retained));
      if ($this.z4k_1 === 0 && !(byte === $this.s4k_1.r2($this.z4k_1))) {
        yield* writeByte($this.t4k_1, byte, $completion);
        var _unary__edvuaz = $this.y4k_1;
        $this.y4k_1 = add(_unary__edvuaz, get_ONE());
        return false;
      }
    }
    $this.z4k_1 = $this.z4k_1 + 1 | 0;
    if ($this.z4k_1 === $this.s4k_1.q2()) {
      return true;
    }
    $this.x4k_1.b4h(byte);
  }
  return false;
}
function checkBounds($this, extra) {
  if (add($this.y4k_1, extra) > $this.u4k_1) {
    throw IOException().l4i('Limit of ' + $this.u4k_1.toString() + ' bytes exceeded ' + ('while searching for "' + toSingleLineString($this, $this.s4k_1) + '"'));
  }
}
function toSingleLineString($this, $receiver) {
  return replace(decodeToString($receiver), '\n', '\\n');
}
var ByteChannelScannerClass;
function ByteChannelScanner() {
  if (ByteChannelScannerClass === VOID) {
    class $ {
      constructor(channel, matchString, writeChannel, limit) {
        limit = limit === VOID ? 9223372036854775807n : limit;
        this.r4k_1 = channel;
        this.s4k_1 = matchString;
        this.t4k_1 = writeChannel;
        this.u4k_1 = limit;
        // Inline function 'kotlin.require' call
        if (!(this.s4k_1.q2() > 0)) {
          var message = 'Empty match string not permitted for scanning';
          throw IllegalArgumentException().o2(toString(message));
        }
        this.v4k_1 = this.r4k_1.m4j();
        this.w4k_1 = buildPartialMatchTable(this);
        this.x4k_1 = new (Buffer())();
        this.y4k_1 = 0n;
        this.z4k_1 = 0;
      }
      *a4l(ignoreMissing, $completion) {
        this.y4k_1 = 0n;
        while (!this.v4k_1.w3v() || (yield* this.r4k_1.l4k(VOID, $completion))) {
          yield* /*#__NOINLINE__*/advanceToNextPotentialMatch(this, $completion);
          if (yield* /*#__NOINLINE__*/checkFullMatch(this, $completion)) {
            return this.y4k_1;
          }
        }
        if (!ignoreMissing) {
          throw IOException().l4i('Expected "' + toSingleLineString(this, this.s4k_1) + '" but encountered end of input');
        }
        this.y4k_1 = add(this.y4k_1, this.x4k_1.n4g(this.t4k_1.s4j()));
        yield* this.t4k_1.m4k($completion);
        return this.y4k_1;
      }
    }
    initMetadataForClass($, 'ByteChannelScanner', VOID, VOID, VOID, [1, 0]);
    ByteChannelScannerClass = $;
  }
  return ByteChannelScannerClass;
}
//region block: exports
export {
  ByteChannelScanner as ByteChannelScanner1h148q1m3y1ey,
};
//endregion

//# sourceMappingURL=ByteChannelScanner.mjs.map
